// File: cgp-sidenav-item.component.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav item component.
// Other Contributors:

import { Component, Input } from '@angular/core';

import { CgpSidenavService } from '../cgp-sidenav.service';

@Component({
    selector: 'cgp-sidenav-item',
    templateUrl: './cgp-sidenav-item.template.html',
    styleUrls: ['./cgp-sidenav-item.style.scss']
})
export class CgpSidenavItemComponent {
    @Input('item') item;

    constructor(public cgpSidenavService: CgpSidenavService) {}

    itemHasChildren = () => {
        return this.item.children && this.item.children.length > 0;
    }

    itemHasIcon = () => {
        return (this.item.iconClass !== undefined && this.item.iconClass !== null);
    }

    toggleExpanded = (e) => {
        e.stopPropagation();

        if (this.item.disabled) {
            return;
        }

        this.item.expanded = !this.item.expanded;
    }

    onItemClick = (e) => {
        const item = this.item;

        e.stopPropagation();

        if (item.disabled) {
            return;
        }

        this.cgpSidenavService.deselectItems();
        item.selected = true;

        if (item.url) {
            window.open(item.url, item.target || '_self');
            return;
        }

        if (item.action) {
            this.cgpSidenavService.doAction(item);
            return;
        }
    }
}
